import { render, staticRenderFns } from "./FieldTypeIcon.vue?vue&type=template&id=4d741455"
import script from "./FieldTypeIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldTypeIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports